import { useState, useEffect } from "react";
import { Typography, Snackbar, Alert } from "@mui/material";
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,

} from "@mui/material";


import "./CreateProductForm.css";
import { useDispatch, useSelector } from "react-redux";
import { createProduct } from "../../../Redux/Customers/Product/Action";


// Commented by Akhil - Box sizes with fixed weights for product packaging
const initialSizes = [
  { name: "One Unit", quantity: 0 },
  { name: "Small Box", quantity: 0 },
  { name: "Large Box", quantity: 0 },
  { name: "XL Box", quantity: 0 },
  { name: "Bulk Box", quantity: 0 }
];

// Category options for dropdowns - values use existing DB category names
// Labels show user-friendly fruit names
const topLevelCategories = [
  { value: 'seasonal_fruits', label: 'Seasonal Fruits' },
  { value: 'tropical_fruits', label: 'Tropical Fruits' },
];

const secondLevelCategories = {
  seasonal_fruits: [
    { value: 'seasonal_produce', label: 'Seasonal Produce' },
  ],
  tropical_fruits: [
    { value: 'fresh_fruits', label: 'Fresh Fruits' },
  ],
};

const thirdLevelCategories = {
  seasonal_produce: [
    { value: 'summer_fruits', label: 'Summer Fruits' },
    { value: 'winter_fruits', label: 'Winter Fruits' },
    { value: 'monsoon_fruits', label: 'Monsoon Fruits' },
    { value: 'all_season', label: 'All Season' },
  ],
  fresh_fruits: [
    { value: 'mangoes', label: 'Mangoes' },
    { value: 'guava', label: 'Guava' },
    { value: 'sapota', label: 'Sapota' },
    { value: 'seethaphal', label: 'Seethaphal' },
    { value: 'custard_apple', label: 'Custard Apple' },
    { value: 'grapes', label: 'Grapes' },
    { value: 'watermelon', label: 'Watermelon' },
    { value: 'papaya', label: 'Papaya' },
    { value: 'mixed_fruit_baskets', label: 'Mixed Fruit Baskets' },
  ],
};

const CreateProductForm = () => {

  const [productData, setProductData] = useState({
    imageUrl: "",
    brand: "Siri Farms", // Default brand
    title: "",
    color: "",
    discountedPrice: "",
    price: "",
    discountPersent: "",
    size: initialSizes,
    quantity: "",
    topLavelCategory: "",
    secondLavelCategory: "",
    thirdLavelCategory: "",
    description: "",
    vendor: "",
    vendorPrice: "",
  });
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt")
  const { customersProduct } = useSelector(store => store);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Handle success/error state from Redux
  useEffect(() => {
    if (customersProduct.error) {
      setSnackbarMessage(customersProduct.error);
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  }, [customersProduct.error]);

  // Auto-calculate total quantity from box sizes
  useEffect(() => {
    const totalQuantity = productData.size.reduce((acc, curr) => acc + (parseInt(curr.quantity) || 0), 0);
    setProductData((prev) => ({
      ...prev,
      quantity: totalQuantity,
    }));
  }, [productData.size]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Reset lower level categories when higher level changes
    if (name === 'topLavelCategory') {
      setProductData((prevState) => ({
        ...prevState,
        secondLavelCategory: '',
        thirdLavelCategory: '',
      }));
    } else if (name === 'secondLavelCategory') {
      setProductData((prevState) => ({
        ...prevState,
        thirdLavelCategory: '',
      }));
    }
  };

  const handleSizeChange = (e, index) => {
    let { name, value } = e.target;
    name === "size_quantity" ? name = "quantity" : name = e.target.name;

    const sizes = [...productData.size];
    sizes[index][name] = value;
    setProductData((prevState) => ({
      ...prevState,
      size: sizes,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Filter out sizes with 0 quantity
    const activeSizes = productData.size.filter(s => parseInt(s.quantity) > 0);

    if (activeSizes.length === 0) {
      setSnackbarMessage("Please add at least one box size with quantity > 0");
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      return;
    }

    // Calculate total quantity from box sizes if not explicitly provided
    const totalQuantity = productData.size.reduce((acc, curr) => acc + (parseInt(curr.quantity) || 0), 0);

    const finalData = {
      ...productData,
      size: activeSizes, // Only send active sizes to backend
      quantity: productData.quantity || totalQuantity
    };

    try {
      await dispatch(createProduct({ data: finalData, jwt }));
      setSnackbarMessage("Product created successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      // Reset form
      setProductData({
        imageUrl: "",
        brand: "Siri Farms",
        title: "",
        color: "",
        discountedPrice: "",
        price: "",
        discountPersent: "",
        size: initialSizes.map(s => ({ ...s, quantity: 0 })),
        quantity: "",
        topLavelCategory: "",
        secondLavelCategory: "",
        thirdLavelCategory: "",
        description: "",
        vendor: "",
        vendorPrice: "",
      });
    } catch (err) {
      console.error("Failed to create product", err);
    }
  };

  // Get second level options based on selected top level category
  const getSecondLevelOptions = () => {
    const topLevel = productData.topLavelCategory;
    if (topLevel && secondLevelCategories[topLevel]) {
      return secondLevelCategories[topLevel];
    }
    return [];
  };

  // Get third level options based on selected second level category
  const getThirdLevelOptions = () => {
    const secondLevel = productData.secondLavelCategory;
    if (secondLevel && thirdLevelCategories[secondLevel]) {
      return thirdLevelCategories[secondLevel];
    }
    return [];
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div className="createProductContainer ">
      <Typography
        variant="h3"
        sx={{ textAlign: "center", mb: 4, fontWeight: 'bold', color: '#4A7C3F' }}
        className="py-10 text-center "
      >
        Add New Fresh Product
      </Typography>
      <form
        onSubmit={handleSubmit}
        className="createProductContainer min-h-screen"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Image URL"
              name="imageUrl"
              value={productData.imageUrl}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Brand"
              name="brand"
              value={productData.brand}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title (e.g. Premium Banganapalli Mangoes)"
              name="title"
              value={productData.title}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Variety/Color (e.g. Yellow / Golden)"
              name="color"
              value={productData.color}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Overall Stock Quantity (auto-calculated from boxes)"
              name="quantity"
              value={productData.quantity}
              type="number"
              required
              InputProps={{ readOnly: true }}
              helperText="Auto-calculated from box quantities below"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Vendor Name"
              name="vendor"
              value={productData.vendor}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Vendor Price"
              name="vendorPrice"
              value={productData.vendorPrice}
              onChange={handleChange}
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Base Price (per LB)"
              name="price"
              value={productData.price}
              onChange={handleChange}
              type="number"
              required
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Discounted Price (per LB)"
              name="discountedPrice"
              value={productData.discountedPrice}
              onChange={handleChange}
              type="number"
              required
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Discount Percentage"
              name="discountPersent"
              value={productData.discountPersent}
              onChange={handleChange}
              type="number"
              required
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth required>
              <InputLabel>Top Level Category</InputLabel>
              <Select
                name="topLavelCategory"
                value={productData.topLavelCategory}
                onChange={handleChange}
                label="Top Level Category"
              >
                {topLevelCategories.map((cat) => (
                  <MenuItem key={cat.value} value={cat.value}>{cat.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth required>
              <InputLabel>Second Level Category</InputLabel>
              <Select
                name="secondLavelCategory"
                value={productData.secondLavelCategory}
                onChange={handleChange}
                label="Second Level Category"
                disabled={!productData.topLavelCategory}
              >
                {getSecondLevelOptions().map((cat) => (
                  <MenuItem key={cat.value} value={cat.value}>{cat.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth required>
              <InputLabel>Third Level Category</InputLabel>
              <Select
                name="thirdLavelCategory"
                value={productData.thirdLavelCategory}
                onChange={handleChange}
                label="Third Level Category"
                disabled={!productData.secondLavelCategory}
              >
                {getThirdLevelOptions().map((cat) => (
                  <MenuItem key={cat.value} value={cat.value}>{cat.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Description"
              multiline
              name="description"
              rows={4}
              onChange={handleChange}
              value={productData.description}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Box Inventory Tracking</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Specify how many boxes of each size are available in stock.
            </Typography>
          </Grid>
          {productData.size.map((size, index) => (
            <Grid container item spacing={3} key={size.name}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Box Size"
                  name="name"
                  value={size.name}
                  onChange={(event) => handleSizeChange(event, index)}
                  required
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Available Boxes"
                  name="size_quantity"
                  type="number"
                  value={size.quantity}
                  onChange={(event) => handleSizeChange(event, index)}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
          ))}
          <Grid item xs={12} sx={{ mt: 4 }}>
            <Button
              variant="contained"
              sx={{ p: 1.5, minWidth: '200px', fontWeight: 'bold', fontSize: '1rem' }}
              color="primary"
              size="large"
              type="submit"
              disabled={customersProduct.loading}
            >
              {customersProduct.loading ? "Creating..." : "Confirm & Add Product"}
            </Button>
          </Grid>
        </Grid>

        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </form>
    </div>
  );
};

export default CreateProductForm;

